export default __webpack_public_path__ + "static/media/gallery_01.32029629.jpg";